module.exports = __webpack_public_path__ + "static/media/radiobutton.da5b3b5b.svg";